import { render, staticRenderFns } from "./audioSelector.vue?vue&type=template&id=7ad8b488"
import script from "./audioSelector.vue?vue&type=script&lang=js"
export * from "./audioSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports